






import { Component, Vue } from "vue-property-decorator";
import { Image, Lazyload } from 'vant';
import { getQueryParam } from "@/utils/index";

@Component({})
export default class NewsDetail extends Vue {
    url: string = "";

    mounted() {
        this.url = decodeURI(getQueryParam(this.$route, "url"));

    }
}
